import { render, staticRenderFns } from "./SliderV3.vue?vue&type=template&id=3ec35a38&"
import script from "./SliderV3.vue?vue&type=script&lang=js&"
export * from "./SliderV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports